import { render, staticRenderFns } from "./EditPurchasesPaymentComponent.vue?vue&type=template&id=048c5f02"
import script from "./EditPurchasesPaymentComponent.vue?vue&type=script&lang=js"
export * from "./EditPurchasesPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports